/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
import { CustomIconProps } from 'types'
import { Box } from '@chakra-ui/react'


const MonitorOutline = createIcon({
  displayName: 'MonitorOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        x1="16"
        y1="21"
        x2="8"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect
        x="2"
        y="3"
        width="20"
        height="14"
        rx="2"
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14,17v1c0,1.65685.67157,3,1.5,3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M10,17v1c0,1.65685-.67157,3-1.5,3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />

    </>
  ),
})

const MonitorTwoTone = createIcon({
  displayName: 'MonitorTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="line"
        x1="16"
        y1="21"
        x2="8"
        y2="21"
        fill="red"
        stroke="red"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect
        x="2"
        y="3"
        width="20"
        height="14"
        rx="2"
        strokeWidth="1.5"
        stroke="blue"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Box as="path"
        d="M14,17v1c0,1.65685.67157,3,1.5,3"
        fill="red"
        stroke="green"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box as="path"
        d="M10,17v1c0,1.65685-.67157,3-1.5,3"
        fill="red"
        stroke="red"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />

    </>
  ),
})

const Monitor: FC<CustomIconProps> = (props) => {
  if (props.variant === 'variant') return <CustomIcon as={MonitorTwoTone} {...props} />
  return <CustomIcon as={MonitorOutline} {...props} />
}

export default memo(Monitor)
